<template>
  <div>
    <signalr path="/hub/inventario" @change="notificacionInventario"></signalr>
    <notifications group="inventario" position="bottom right" :duration="10000" />

    <v-dialog v-model="dialogSaved" persistent max-width="40%">
      <v-card>
        <v-card-text class="text-center">
          <lottie id="montacargasSaved" :options="checkOptions" :height="200" :width="200" />
          <h3>Movimiento Realizado Correctamente</h3>
          <a
            v-if="qrPdf && qrPdf.length > 0"
            class="headline"
            target="__blank"
            :href="'/api/Inventario/DescargarQR/' + qrPdf + '?access_token=' + token"
          >
            <v-icon color="primary" large>mdi-download</v-icon>
            Descargar Códigos QR
          </a>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="success" @click="cerrarDialogSaved()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card flat>
      <v-card-title>{{ modoProduccion ? 'Salida de MP a Producción por Pistoleo (Montacargas)' : 'Movimiento entre Almacenes por Pistoleo (Montacargas)' }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="py-0">
            <v-switch
              v-model="modoProduccion"
              inset
              dense
              hide-details
              class="mt-0"
              :disabled="saving"
              :label="modoProduccion ? 'Modo: Salida de MP a Producción (ODT)' : 'Modo: Transferencia entre Almacenes'"
              @change="onCambioModo"
            ></v-switch>
          </v-col>
          <v-col v-if="modoProduccion" cols="12" md="6" class="py-0">
            <v-autocomplete
              v-model="idTrabajoOrden"
              label="Orden de Trabajo"
              :items="trabajoOrdenes"
              item-value="idTrabajoOrden"
              item-text="nombre"
              clearable
              :disabled="saving"
              @change="onChangeODT"
            ></v-autocomplete>
          </v-col>
          <v-col v-if="modoProduccion" cols="12" md="6" class="py-0">
            <v-autocomplete
              v-model="idTrabajoOrdenDetalle"
              label="Artículo a Producir"
              :items="trabajoOrdenDetalles"
              item-value="idTrabajoOrdenDetalle"
              item-text="articulo"
              clearable
              :disabled="saving || idTrabajoOrden == null"
              :placeholder="idTrabajoOrden == null ? 'Selecciona primero la ODT' : ''"
              :persistent-placeholder="idTrabajoOrden == null"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" class="d-flex flex-column">
            <div class="mb-auto">
              <div
                v-if="camaraError"
                class="pa-3 mb-2 grey lighten-3 rounded d-flex align-center justify-center text-center"
                style="min-height: 15.625rem"
              >
                <div>
                  <v-icon size="48" color="grey darken-1">mdi-camera-off</v-icon>
                  <p class="mt-2 mb-0 caption grey--text text--darken-2">{{ camaraError }}</p>
                  <p class="mb-0 caption grey--text">Puedes seguir pistoleando con la pistola en el campo de abajo.</p>
                </div>
              </div>
              <QrcodeStream v-else @decode="onDecode" @init="onInit" style="height: 15.625rem" />
              <v-text-field
                v-model="codigo"
                label="Código de Identificación"
                hide-details
                @keydown.enter="getCode"
                @keyup="setCodeStyle"
                maxlength="12"
                :error="codigoValido"
                class="py-4"
                :disabled="saving"
              ></v-text-field>
              <v-select
                v-model="selectCode"
                label="Lectura Remota"
                :loading="loadingLecturasRemotas"
                :items="lecturasRemotas"
                item-value="codigo"
                item-text="codigo"
                @change="selectedCode"
                :disabled="saving"
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title>{{ data.item.codigo }}</v-list-item-title>
                    <v-list-item-subtitle>Artículo: {{ data.item.articulo }}</v-list-item-subtitle>
                    <v-list-item-subtitle>Almacén: {{ data.item.almacen }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>
            </div>
          </v-col>
          <v-col cols="12" md="9">
            <v-data-table
              v-if="!modoProduccion"
              :items="datosQR"
              :headers="datosQRHeaders"
              :items-per-page="-1"
              :loading="loading"
              hide-default-footer
              no-data-text="Pistolea un artículo para transferirlo"
            >
              <template v-slot:[`item.row`]="{ index }">{{ index + 1 }}</template>
              <template v-slot:[`item.detalles`]="{ item }">
                <div class="py-1">
                  <p class="mb-2"><span class="font-weight-bold">QR:</span> {{ setCodeStyleReturn(item.codigo) }}</p>
                  <p class="mb-2"><span class="font-weight-bold">Artículo:</span> {{ item.articulo }}</p>
                  <p class="mb-2"><span class="font-weight-bold">Almacén origen:</span> {{ item.almacen }}</p>
                  <p class="mb-2"><span class="font-weight-bold">Subalmacén origen:</span> {{ item.subalmacen || "N/A" }}</p>
                  <p class="mb-2">
                    <span class="font-weight-bold">Cantidad restante:</span>
                    {{ `${item.maximo} ${$utils.strings.pluralizar(item.abreviatura, item.maximo, false)}` }}
                  </p>
                </div>
              </template>
              <template v-slot:[`item.almacenDestino`]="{ item }">
                <v-autocomplete
                  v-model="item.idAlmacenDestino"
                  label="Almacén"
                  :items="almacenesDestino(item)"
                  :item-text="nombreAlmacen"
                  item-value="idAlmacen"
                  clearable
                  :disabled="saving"
                  :error-messages="item.errorAlmacen"
                  @focus="$set(item, 'errorAlmacen', '')"
                  @change="changeAlmacenDestino(item)"
                ></v-autocomplete>
              </template>
              <template v-slot:[`item.subalmacenDestino`]="{ item }">
                <v-autocomplete
                  v-model="item.idSubalmacenDestino"
                  label="[Opcional] Subalmacén"
                  :items="subalmacenesFiltrados(item)"
                  :item-text="nombreSubalmacen"
                  item-value="idSubalmacen"
                  clearable
                  :disabled="saving"
                ></v-autocomplete>
              </template>
              <template v-slot:[`item.cantidad`]="{ item }">
                <v-text-field
                  v-model="item.cantidad"
                  :label="`Máximo: ${item.maximo} ${$utils.strings.pluralizar(item.abreviatura, item.maximo, false)}`"
                  type="number"
                  hide-spin-buttons
                  :suffix="$utils.strings.pluralizar(item.abreviatura, item.cantidad, false)"
                  :error="parseFloat(item.cantidad) > parseFloat(item.maximo)"
                  :disabled="saving"
                  :error-messages="item.errorCantidad"
                  @focus="$set(item, 'errorCantidad', '')"
                ></v-text-field>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom color="black" class="white--text">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small :disabled="saving" @click="deleteItemQR(item)">delete</v-icon>
                  </template>
                  <span class="white--text">Eliminar</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <v-data-table
              v-else
              :items="salidasProduccion"
              :headers="salidasProduccionHeaders"
              :items-per-page="-1"
              :loading="loading"
              hide-default-footer
              no-data-text="Selecciona ODT y artículo a producir, luego pistolea la materia prima"
            >
              <template v-slot:[`item.row`]="{ index }">{{ index + 1 }}</template>
              <template v-slot:[`item.detalles`]="{ item }">
                <div class="py-1">
                  <p class="mb-2"><span class="font-weight-bold">QR:</span> {{ setCodeStyleReturn(item.codigo) }}</p>
                  <p class="mb-2"><span class="font-weight-bold">Materia prima:</span> {{ item.articulo }}</p>
                  <p class="mb-2"><span class="font-weight-bold">Almacén origen:</span> {{ item.almacen }}</p>
                  <p class="mb-2"><span class="font-weight-bold">Subalmacén origen:</span> {{ item.subalmacen || "N/A" }}</p>
                </div>
              </template>
              <template v-slot:[`item.cantidad`]="{ item }">
                {{ `${item.maximo} ${$utils.strings.pluralizar(item.abreviatura, item.maximo, false)}` }}
                <div class="caption grey--text">Se envía completa</div>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom color="black" class="white--text">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small :disabled="saving" @click="deleteSalidaProduccion(item)">delete</v-icon>
                  </template>
                  <span class="white--text">Eliminar</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          text
          @click="save()"
          :disabled="saving || (modoProduccion ? salidasProduccion.length == 0 : datosQR.length == 0)"
          :loading="saving"
        >Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import { QrcodeStream } from "vue-qrcode-reader";
import { mapState } from "vuex";
import signalr from "@/components/SignalR";
import { Howl } from "howler";
import Lottie from "vue-lottie";
import * as checkData from "@/assets/check.json";

export default {
  components: {
    lottie: Lottie,
    QrcodeStream,
    signalr,
  },
  data() {
    return {
      checkOptions: {
        animationData: checkData.default,
        loop: false,
        speeed: 0.5,
      },
      dialogSaved: false,
      camaraError: "",
      qrPdf: "",
      saving: false,
      loading: false,
      almacenes: [],
      subalmacenes: [],
      soundBeep: null,
      soundError: null,
      lecturasRemotas: [],
      loadingLecturasRemotas: false,
      selectCode: null,
      codigo: "",
      datosQR: [],
      modoProduccion: false,
      trabajoOrdenes: [],
      trabajoOrdenDetalles: [],
      idTrabajoOrden: null,
      idTrabajoOrdenDetalle: null,
      salidasProduccion: [],
      salidasProduccionHeaders: [
        { text: "#", align: "center", value: "row", width: "5%" },
        { text: "Detalles del QR", align: "center", value: "detalles" },
        { text: "Cantidad a Enviar", align: "center", value: "cantidad", width: "22%" },
        { text: "", align: "center", value: "actions", width: "5%" },
      ],
      datosQRHeaders: [
        { text: "#", align: "center", value: "row", width: "5%" },
        { text: "Detalles del QR", align: "center", value: "detalles" },
        { text: "Almacén Destino", align: "center", value: "almacenDestino" },
        { text: "Subalmacén Destino", align: "center", value: "subalmacenDestino" },
        { text: "Cantidad a Transferir", align: "center", value: "cantidad", width: "18%" },
        { text: "", align: "center", value: "actions", width: "5%" },
      ],
    };
  },
  computed: {
    ...mapState(["idUser", "token"]),
    codigoValido() {
      if (!(!(this.codigo.length >= 11 && this.codigo.length <= 12) && this.codigo.length >= 1)) return false;
      if (this.codigo[0] == "@") return this.onlyNumberAndLetters(this.codigo.substring(1).replace(/-/g, ""));
      return this.onlyNumberAndLetters(this.codigo.replace(/-/g, ""));
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    async onInit(promise) {
      try {
        await promise;
        this.camaraError = "";
      } catch (error) {
        const nombre = error && error.name ? error.name : "";
        const mensajes = {
          NotAllowedError: "Permiso de cámara denegado. Habilítalo en el navegador (candado → Cámara).",
          NotFoundError: "No se detectó ninguna cámara en este equipo.",
          NotSupportedError: "La cámara requiere conexión segura (HTTPS)",
          InsecureContextError: "La cámara requiere conexión segura (HTTPS).",
          NotReadableError: "La cámara está siendo usada por otra aplicación.",
          OverconstrainedError: "No se encontró una cámara compatible.",
          StreamApiNotSupportedError: "Este navegador no soporta el acceso a la cámara.",
        };
        this.camaraError = mensajes[nombre] || "No se pudo iniciar la cámara.";
        console.log("QR init error:", error);
      }
    },
    nombreSubalmacen: ({ clave, subalmacen }) => `[${clave}] - ${subalmacen}`.trim(),
    nombreAlmacen: ({ codigo, nombre }) => `[${codigo}] - ${nombre}`.trim(),
    onlyNumberAndLetters: (str) => str.match("^[A-Z0-9-]+$"),
    // Solo se permite mover a almacenes distintos al de origen del elemento.
    almacenesDestino(item) {
      return this.almacenes.filter((a) => a.idCliente == null && a.idAlmacen != item.idAlmacen);
    },
    subalmacenesFiltrados({ idAlmacenDestino }) {
      if (idAlmacenDestino == null) return [];
      return this.subalmacenes.filter((subalm) => subalm.idAlmacen == idAlmacenDestino);
    },
    changeAlmacenDestino(item) {
      this.$set(item, "idSubalmacenDestino", null);
    },
    validate() {
      let hayErrores = false;
      if (this.datosQR.length == 0) {
        this.soundError.play();
        this.$notify({ group: "inventario", title: "Debe pistolear al menos un artículo", type: "error" });
        return false;
      }
      this.datosQR.forEach((item) => {
        this.$set(item, "errorAlmacen", "");
        this.$set(item, "errorCantidad", "");
        if (item.idAlmacenDestino == null) {
          this.$set(item, "errorAlmacen", "Requerido");
          hayErrores = true;
        } else if (item.idAlmacenDestino == item.idAlmacen) {
          this.$set(item, "errorAlmacen", "Debe ser un almacén distinto al de origen");
          hayErrores = true;
        }
        if (isNaN(parseFloat(item.cantidad)) || parseFloat(item.cantidad) <= 0) {
          this.$set(item, "errorCantidad", "Cantidad inválida");
          hayErrores = true;
        } else if (parseFloat(item.cantidad) > item.maximo) {
          this.$set(
            item,
            "errorCantidad",
            `Máximo: ${item.maximo} ${this.$utils.strings.pluralizar(item.abreviatura, item.maximo, false)}`
          );
          hayErrores = true;
        }
      });
      return !hayErrores;
    },
    save() {
      if (this.modoProduccion) {
        this.saveProduccion();
        return;
      }
      if (!this.validate()) return;
      const movimientos = this.datosQR.map((item) => ({
        IdAlmacen: item.idAlmacenDestino,
        IdSubalmacen: item.idSubalmacenDestino,
        IdElemento: item.idElemento,
        Cantidad: parseFloat(item.cantidad),
      }));
      this.saving = true;
      axios
        .post("/Inventario/CrearMovimientoMontacargas", movimientos)
        .then((response) => {
          this.saving = false;
          this.limpiar();
          this.$emit("initialize");
          if (response.data != null && response.data.length > 0) {
            this.qrPdf = response.data;
          }
          this.dialogSaved = true;
        })
        .catch((error) => {
          this.saving = false;
          this.soundError.play();
          this.$notify({
            group: "inventario",
            title: "No se pudo realizar el movimiento entre almacenes",
            type: "error",
          });
          console.log(error);
        });
    },
    deleteItemQR(item) {
      const index = this.datosQR.indexOf(item);
      this.datosQR.splice(index, 1);
    },
    notificacionInventario(event) {
      const orden = event.toLowerCase().split("-");
      if (orden[0] == "lecturaremota" && this.idUser == parseInt(orden[1])) {
        this.getLecturasRemotas();
      }
    },
    selectedCode(event) {
      this.onDecode(event);
      setTimeout(() => {
        this.selectCode = null;
      }, 200);
    },
    setCodeStyle() {
      if (this.codigo.length >= 1) {
        try {
          if (this.codigo[0] == "@" && this.codigo.length > 1) {
            this.codigo = "@" + this.codigo.substring(1).toUpperCase().replace(/-/g, "").match(/.{1,3}/g).join("-");
          } else {
            this.codigo = this.codigo.toUpperCase().replace(/-/g, "").match(/.{1,3}/g).join("-");
          }
        } catch {
          this.codigo = "";
        }
      }
    },
    getCode() {
      var codigo = this.codigo.toUpperCase().replace(/-/g, "");
      if (codigo.length == 10 && codigo[0] == "@") {
        this.onDecode(codigo);
        this.codigo = "";
      }
      if (codigo.length == 9 && this.onlyNumberAndLetters(codigo)) {
        this.onDecode(codigo);
        this.codigo = "";
      }
    },
    setCodeStyleReturn(codigo) {
      if (codigo.length >= 1) {
        try {
          if (codigo[0] == "@" && codigo.length > 1) {
            return "@" + codigo.substring(1).toUpperCase().replace(/-/g, "").match(/.{1,3}/g).join("-");
          }
          return codigo.toUpperCase().replace(/-/g, "").match(/.{1,3}/g).join("-");
        } catch {
          return "";
        }
      }
    },
    onDecode(code) {
      if (this.modoProduccion) {
        this.onDecodeProduccion(code);
        return;
      }
      if (this.datosQR.find((item) => item.codigo == code)) {
        this.soundError.play();
        this.$notify({
          group: "inventario",
          title: "Ya se agregó el Elemento con el Código " + code.match(/.{1,3}/g).join("-"),
          type: "error",
        });
        return;
      }
      this.loading = true;
      axios
        .get("/Inventario/InformacionBasica", { params: { codigo: code, tipoMovimiento: 6 } })
        .then((response) => {
          if (response.data.enUso) {
            this.soundError.play();
            this.$notify({
              group: "inventario",
              title:
                "No se puede agregar el Elemento con el Código " +
                code.match(/.{1,3}/g).join("-") +
                " se encuentra en uso en otra ODT",
              type: "error",
            });
            return;
          }
          if (response.data.maximo <= 0) {
            this.soundError.play();
            this.$notify({
              group: "inventario",
              title: "La existencia de este Elemento es 0.0 " + response.data.abreviatura,
              type: "error",
            });
            return;
          }
          const idsAlmacenes = this.almacenes.filter((a) => a.idCliente == null).map((a) => a.idAlmacen);
          if (idsAlmacenes.indexOf(response.data.idAlmacen) >= 0) {
            response.data.cantidad = 0;
            this.datosQR.push(response.data);
            this.soundBeep.play();
          } else {
            this.soundError.play();
            this.$notify({
              group: "inventario",
              title: "No se puede agregar el Elemento con el Código " + code.match(/.{1,3}/g).join("-"),
              type: "error",
            });
          }
        })
        .catch(() => {
          this.soundError.play();
          this.$notify({
            group: "inventario",
            title: "No Existe un Elemento con el Código " + code.match(/.{1,3}/g).join("-"),
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cerrarDialogSaved() {
      this.dialogSaved = false;
      this.$nextTick(() => {
        this.qrPdf = "";
      });
    },
    limpiar() {
      this.codigo = "";
      this.selectCode = null;
      this.datosQR = [];
      this.salidasProduccion = [];
    },
    onCambioModo() {
      this.limpiar();
      this.idTrabajoOrden = null;
      this.idTrabajoOrdenDetalle = null;
      this.trabajoOrdenDetalles = [];
      this.camaraError = "";
    },
    onChangeODT() {
      this.idTrabajoOrdenDetalle = null;
      const ot = this.trabajoOrdenes.find((o) => o.idTrabajoOrden == this.idTrabajoOrden);
      this.trabajoOrdenDetalles = ot && ot.detalles ? ot.detalles : [];
    },
    onDecodeProduccion(code) {
      if (this.idTrabajoOrden == null || this.idTrabajoOrdenDetalle == null) {
        this.soundError.play();
        this.$notify({
          group: "inventario",
          title: "Selecciona primero la Orden de Trabajo y el Artículo a Producir",
          type: "error",
        });
        return;
      }
      if (this.salidasProduccion.find((item) => item.codigo == code)) {
        this.soundError.play();
        this.$notify({
          group: "inventario",
          title: "Ya se agregó el Elemento con el Código " + code.match(/.{1,3}/g).join("-"),
          type: "error",
        });
        return;
      }
      this.loading = true;
      axios
        .get("/Inventario/InformacionBasica", { params: { codigo: code, tipoMovimiento: 1 } })
        .then((response) => {
          if (response.data.enUso) {
            this.soundError.play();
            this.$notify({
              group: "inventario",
              title:
                "No se puede agregar el Elemento con el Código " +
                code.match(/.{1,3}/g).join("-") +
                " se encuentra en uso en otra ODT",
              type: "error",
            });
            return;
          }
          if (response.data.maximo <= 0) {
            this.soundError.play();
            this.$notify({
              group: "inventario",
              title: "La existencia de este Elemento es 0.0 " + response.data.abreviatura,
              type: "error",
            });
            return;
          }
          const idsAlmacenes = this.almacenes.filter((a) => a.idCliente == null).map((a) => a.idAlmacen);
          if (idsAlmacenes.indexOf(response.data.idAlmacen) >= 0) {
            this.salidasProduccion.push(response.data);
            this.soundBeep.play();
          } else {
            this.soundError.play();
            this.$notify({
              group: "inventario",
              title: "No se puede agregar el Elemento con el Código " + code.match(/.{1,3}/g).join("-"),
              type: "error",
            });
          }
        })
        .catch(() => {
          this.soundError.play();
          this.$notify({
            group: "inventario",
            title: "No Existe un Elemento con el Código " + code.match(/.{1,3}/g).join("-"),
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteSalidaProduccion(item) {
      const index = this.salidasProduccion.indexOf(item);
      this.salidasProduccion.splice(index, 1);
    },
    validateProduccion() {
      if (this.idTrabajoOrden == null) {
        this.$notify({ group: "inventario", title: "Selecciona la Orden de Trabajo", type: "error" });
        return false;
      }
      if (this.idTrabajoOrdenDetalle == null) {
        this.$notify({ group: "inventario", title: "Selecciona el Artículo a Producir", type: "error" });
        return false;
      }
      if (this.salidasProduccion.length == 0) {
        this.soundError.play();
        this.$notify({ group: "inventario", title: "Pistolea al menos una materia prima", type: "error" });
        return false;
      }
      return true;
    },
    saveProduccion() {
      if (!this.validateProduccion()) return;
      const payload = {
        IdTrabajoOrden: this.idTrabajoOrden,
        IdTrabajoOrdenDetalle: this.idTrabajoOrdenDetalle,
        IdsElemento: this.salidasProduccion.map((s) => s.idElemento),
      };
      this.saving = true;
      axios
        .post("/Inventario/SalidaProduccionMontacargas", payload)
        .then(() => {
          this.saving = false;
          this.salidasProduccion = [];
          this.codigo = "";
          this.qrPdf = "";
          this.$emit("initialize");
          this.dialogSaved = true;
        })
        .catch((error) => {
          this.saving = false;
          this.soundError.play();
          const mensaje =
            error && error.response && error.response.data && error.response.data.msg
              ? error.response.data.msg
              : "No se pudo realizar la salida a producción";
          this.$notify({ group: "inventario", title: mensaje, type: "error" });
          console.log(error);
        });
    },
    getLecturasRemotas() {
      this.loadingLecturasRemotas = true;
      axios
        .get("/Inventario/ListarQRRemotos")
        .then((response) => {
          this.lecturasRemotas = response.data;
        })
        .catch(console.log)
        .finally(() => {
          this.loadingLecturasRemotas = false;
        });
    },
    initializeSounds() {
      this.soundBeep = new Howl({ src: ["/sounds/beep.webm", "/sounds/beep.mp3"] });
      this.soundError = new Howl({ src: ["/sounds/error.webm", "/sounds/error.mp3"] });
    },
    getAlmacenes() {
      return axios
        .get("/Almacenes")
        .then((response) => {
          this.almacenes = response.data;
        })
        .catch(console.log);
    },
    getSubalmacenes() {
      return axios
        .get("/Subalmacenes")
        .then((response) => {
          this.subalmacenes = response.data;
        })
        .catch(console.log);
    },
    getOTs() {
      return axios
        .get("TrabajoOrdenes/ListarOT?otsCerradas=true")
        .then((response) => {
          this.trabajoOrdenes = response.data;
        })
        .catch(console.log);
    },
    async initialize() {
      this.initializeSounds();
      await Promise.all([this.getAlmacenes(), this.getSubalmacenes()]);
      this.getLecturasRemotas();
      this.getOTs();
      // Deep-link: si llega ?c=<codigo> se auto-pistolea el elemento.
      const codigoDeepLink = this.$route && this.$route.query ? this.$route.query.c : null;
      if (codigoDeepLink) {
        this.onDecode(String(codigoDeepLink).toUpperCase().replace(/-/g, ""));
      }
    },
  },
};
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}
</style>
